import React, { useEffect, useState } from "react";

import styled, { css } from "styled-components";

const SIDEBAR_BASE_WIDTH = 360;
const SIDEBAR_MAX_WIDTH = 1000;
const SIDEBAR_DATA_KEY = "reviewSidebarData";

const MainRow = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    width: 100%;
    position: relative;
`;

const MainSection = styled.main`
    flex: 1;
    height: 100%;
    position: relative;
    overflow: auto;
`;

const Sidebar = styled.aside`
    position: relative;
    width: ${(props) => (props.$isFold ? "auto" : props.$width + "px")};
    max-width: ${SIDEBAR_MAX_WIDTH}px;
    height: calc(100vh - 56px);
    background-color: var(--color-White);
    transition: ${({ $isResizing }) => ($isResizing ? "none" : "all 350ms ease-in-out")};
    display: flex;
    flex-direction: column;
`;

const SidebarResizer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 100%;
    user-select: none;
    z-index: 1;
    background-color: var(--color-Grey3);

    ${(props) =>
        !props.$isFold &&
        css`
            cursor: ew-resize;
            &:hover {
                background-color: var(--color-Key);
            }
        `}
`;

function PDFChatPageLayout({
    main,
    sidebar,
    sidebarKey = SIDEBAR_DATA_KEY,
    sidebarBaseWidth = SIDEBAR_BASE_WIDTH,
    sidebarMaxWidth = SIDEBAR_MAX_WIDTH,
}) {
    const [sidebarWidth, setSidebarWidth] = useState(sidebarBaseWidth);
    const [isSidebarFold, setIsSidebarFold] = useState(false);
    const [isSidebarResizing, setIsSidebarResizing] = useState(false);

    useEffect(() => {
        // fold/width localStorage 저장/불러오기
        const sidebarData = JSON.parse(localStorage.getItem(sidebarKey));
        if (sidebarData) {
            setIsSidebarFold(sidebarData.f || false);
            setSidebarWidth(sidebarData.w || sidebarBaseWidth);
        }
    }, [sidebarKey, sidebarBaseWidth]);

    useEffect(() => {
        localStorage.setItem(sidebarKey, JSON.stringify({ w: sidebarWidth, f: isSidebarFold }));
    }, [sidebarWidth, isSidebarFold, sidebarKey]);

    const handleSidebarResize = (e) => {
        if (isSidebarFold) return;
        const min = 0,
            max = sidebarMaxWidth;
        setSidebarWidth(Math.max(min, Math.min(max, window.innerWidth - e.clientX)));
    };
    const startSidebarResizing = () => {
        if (isSidebarFold) return;
        setIsSidebarResizing(true);
        window.addEventListener("mousemove", handleSidebarResize);
        window.addEventListener("mouseup", stopSidebarResizing);
    };
    const stopSidebarResizing = () => {
        setIsSidebarResizing(false);
        window.removeEventListener("mousemove", handleSidebarResize);
        window.removeEventListener("mouseup", stopSidebarResizing);
    };

    return (
        <MainRow>
            <MainSection>{main}</MainSection>
            <Sidebar $width={sidebarWidth} $isResizing={isSidebarResizing} $isFold={isSidebarFold}>
                <SidebarResizer onMouseDown={startSidebarResizing} $isFold={isSidebarFold} />
                {React.cloneElement(sidebar, { isSidebarFold, setIsSidebarFold })}
            </Sidebar>
        </MainRow>
    );
}

export default PDFChatPageLayout;
